// extracted by mini-css-extract-plugin
export var parcelRow = "_sm-0";